/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PostsIndexRouteImport } from './routes/posts/index'
import { Route as NotesIndexRouteImport } from './routes/notes/index'
import { Route as TagsTagRouteImport } from './routes/tags/$tag'
import { Route as SeriesSlugRouteImport } from './routes/series/$slug'
import { Route as PostsSlugRouteImport } from './routes/posts/$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsIndexRoute = PostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotesIndexRoute = NotesIndexRouteImport.update({
  id: '/notes/',
  path: '/notes/',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsTagRoute = TagsTagRouteImport.update({
  id: '/tags/$tag',
  path: '/tags/$tag',
  getParentRoute: () => rootRouteImport,
} as any)
const SeriesSlugRoute = SeriesSlugRouteImport.update({
  id: '/series/$slug',
  path: '/series/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsSlugRoute = PostsSlugRouteImport.update({
  id: '/posts/$slug',
  path: '/posts/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/posts/$slug': typeof PostsSlugRoute
  '/series/$slug': typeof SeriesSlugRoute
  '/tags/$tag': typeof TagsTagRoute
  '/notes/': typeof NotesIndexRoute
  '/posts/': typeof PostsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/posts/$slug': typeof PostsSlugRoute
  '/series/$slug': typeof SeriesSlugRoute
  '/tags/$tag': typeof TagsTagRoute
  '/notes': typeof NotesIndexRoute
  '/posts': typeof PostsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/posts/$slug': typeof PostsSlugRoute
  '/series/$slug': typeof SeriesSlugRoute
  '/tags/$tag': typeof TagsTagRoute
  '/notes/': typeof NotesIndexRoute
  '/posts/': typeof PostsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/posts/$slug'
    | '/series/$slug'
    | '/tags/$tag'
    | '/notes/'
    | '/posts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/posts/$slug'
    | '/series/$slug'
    | '/tags/$tag'
    | '/notes'
    | '/posts'
  id:
    | '__root__'
    | '/'
    | '/posts/$slug'
    | '/series/$slug'
    | '/tags/$tag'
    | '/notes/'
    | '/posts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PostsSlugRoute: typeof PostsSlugRoute
  SeriesSlugRoute: typeof SeriesSlugRoute
  TagsTagRoute: typeof TagsTagRoute
  NotesIndexRoute: typeof NotesIndexRoute
  PostsIndexRoute: typeof PostsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/': {
      id: '/posts/'
      path: '/posts'
      fullPath: '/posts/'
      preLoaderRoute: typeof PostsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notes/': {
      id: '/notes/'
      path: '/notes'
      fullPath: '/notes/'
      preLoaderRoute: typeof NotesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags/$tag': {
      id: '/tags/$tag'
      path: '/tags/$tag'
      fullPath: '/tags/$tag'
      preLoaderRoute: typeof TagsTagRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/series/$slug': {
      id: '/series/$slug'
      path: '/series/$slug'
      fullPath: '/series/$slug'
      preLoaderRoute: typeof SeriesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/$slug': {
      id: '/posts/$slug'
      path: '/posts/$slug'
      fullPath: '/posts/$slug'
      preLoaderRoute: typeof PostsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PostsSlugRoute: PostsSlugRoute,
  SeriesSlugRoute: SeriesSlugRoute,
  TagsTagRoute: TagsTagRoute,
  NotesIndexRoute: NotesIndexRoute,
  PostsIndexRoute: PostsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
